import { createResourceBuilder } from '../resource';
import { EResourceMethod } from '../models/IPermission';

export const productResources = {
  getProducts: createResourceBuilder('/drmrust/v2.1/admin/products', EResourceMethod.Get),
  createProduct: createResourceBuilder('/drmrust/v2.1/admin/products', EResourceMethod.Post),
  updateProduct: createResourceBuilder(
    '/drmrust/v2.1/admin/products/:product_id',
    EResourceMethod.Put,
    (product_id: string) => ({
      product_id,
    })
  ),
  deleteProduct: createResourceBuilder(
    '/drmrust/v2.1/admin/products/:product_id',
    EResourceMethod.Delete,
    (product_id: string) => ({
      product_id,
    })
  ),
};
